export enum DetailFillSpinnerType {
  MARKET_SPOT,
  MARKET_PTS,
  MARKET_ALL_IN,
  CLIENT_SPOT,
  CLIENT_PTS,
  CLIENT_ALL_IN,
}
